var Re = Object.defineProperty, ze = Object.defineProperties;
var Ee = Object.getOwnPropertyDescriptors;
var $ = Object.getOwnPropertySymbols;
var ae = Object.prototype.hasOwnProperty, ue = Object.prototype.propertyIsEnumerable;
var ie = (e, o, r) => o in e ? Re(e, o, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[o] = r, f = (e, o) => {
  for (var r in o || (o = {}))
    ae.call(o, r) && ie(e, r, o[r]);
  if ($)
    for (var r of $(o))
      ue.call(o, r) && ie(e, r, o[r]);
  return e;
}, S = (e, o) => ze(e, Ee(o));
var P = (e, o) => {
  var r = {};
  for (var t in e)
    ae.call(e, t) && o.indexOf(t) < 0 && (r[t] = e[t]);
  if (e != null && $)
    for (var t of $(e))
      o.indexOf(t) < 0 && ue.call(e, t) && (r[t] = e[t]);
  return r;
};
import { jsx as m, jsxs as We } from "react/jsx-runtime";
import { useRef as E, useEffect as A, useMemo as Le, useCallback as He, forwardRef as T, useState as w } from "react";
import { r as Me } from "./use-floating-auto-update-BPNMj5CZ.js";
import { r as Ve } from "./rem-CMQJ_ZTp.js";
import { u as Xe, c as Ye } from "./use-styles-BXCSW-9F.js";
import { b as te, B as j, j as he } from "./factory-BnRIVbT0.js";
import { c as be } from "./create-safe-context-DqDyoPVE.js";
import { u as Ne } from "./use-isomorphic-effect-CiIycTKV.js";
import { u as F } from "./use-merged-ref-n551Tfbr.js";
import { u as Ue } from "./DirectionProvider-CT8S13Cp.js";
import { t as q } from "./to-int-CHbRl5M-.js";
function N(e) {
  const o = E(e);
  return A(() => {
    o.current = e;
  }), Le(() => (...r) => {
    var t;
    return (t = o.current) == null ? void 0 : t.call(o, ...r);
  }, []);
}
const Oe = () => {
};
function G(e, o) {
  const r = typeof o == "number" ? o : o.delay, t = typeof o == "number" ? !1 : o.flushOnUnmount, s = N(e), l = E(0), n = Object.assign(
    He(
      (...c) => {
        window.clearTimeout(l.current);
        const i = () => {
          l.current !== 0 && (l.current = 0, s(...c));
        };
        n.flush = i, l.current = window.setTimeout(i, r);
      },
      [s, r]
    ),
    { flush: Oe }
  );
  return A(
    () => () => {
      window.clearTimeout(l.current), t && n.flush();
    },
    [n, t]
  ), n;
}
const [Be, D] = be(
  "ScrollArea.Root component was not found in tree"
);
function B(e, o) {
  const r = N(o);
  Ne(() => {
    let t = 0;
    if (e) {
      const s = new ResizeObserver(() => {
        cancelAnimationFrame(t), t = window.requestAnimationFrame(r);
      });
      return s.observe(e), () => {
        window.cancelAnimationFrame(t), s.unobserve(e);
      };
    }
  }, [e, r]);
}
const Fe = T((e, o) => {
  const h = e, { style: r } = h, t = P(h, ["style"]), s = D(), [l, n] = w(0), [c, i] = w(0), d = !!(l && c);
  return B(s.scrollbarX, () => {
    var a;
    const u = ((a = s.scrollbarX) == null ? void 0 : a.offsetHeight) || 0;
    s.onCornerHeightChange(u), i(u);
  }), B(s.scrollbarY, () => {
    var a;
    const u = ((a = s.scrollbarY) == null ? void 0 : a.offsetWidth) || 0;
    s.onCornerWidthChange(u), n(u);
  }), d ? /* @__PURE__ */ m("div", S(f({}, t), { ref: o, style: S(f({}, r), { width: l, height: c }) })) : null;
}), ke = T((e, o) => {
  const r = D(), t = !!(r.scrollbarX && r.scrollbarY);
  return r.type !== "scroll" && t ? /* @__PURE__ */ m(Fe, S(f({}, e), { ref: o })) : null;
}), _e = {
  scrollHideDelay: 1e3,
  type: "hover"
}, fe = T((e, o) => {
  const C = te("ScrollAreaRoot", _e, e), { type: t, scrollHideDelay: s, scrollbars: l } = C, n = P(C, ["type", "scrollHideDelay", "scrollbars"]), [c, i] = w(null), [d, h] = w(null), [u, a] = w(null), [p, b] = w(null), [g, y] = w(null), [x, W] = w(0), [R, V] = w(0), [z, O] = w(!1), [L, X] = w(!1), v = F(o, (H) => i(H));
  return /* @__PURE__ */ m(
    Be,
    {
      value: {
        type: t,
        scrollHideDelay: s,
        scrollArea: c,
        viewport: d,
        onViewportChange: h,
        content: u,
        onContentChange: a,
        scrollbarX: p,
        onScrollbarXChange: b,
        scrollbarXEnabled: z,
        onScrollbarXEnabledChange: O,
        scrollbarY: g,
        onScrollbarYChange: y,
        scrollbarYEnabled: L,
        onScrollbarYEnabledChange: X,
        onCornerWidthChange: W,
        onCornerHeightChange: V
      },
      children: /* @__PURE__ */ m(
        j,
        S(f({}, n), {
          ref: v,
          __vars: {
            "--sa-corner-width": l !== "xy" ? "0px" : `${x}px`,
            "--sa-corner-height": l !== "xy" ? "0px" : `${R}px`
          }
        })
      )
    }
  );
});
fe.displayName = "@mantine/core/ScrollAreaRoot";
function me(e, o) {
  const r = e / o;
  return Number.isNaN(r) ? 0 : r;
}
function J(e) {
  const o = me(e.viewport, e.content), r = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, t = (e.scrollbar.size - r) * o;
  return Math.max(t, 18);
}
function pe(e, o) {
  return (r) => {
    if (e[0] === e[1] || o[0] === o[1])
      return o[0];
    const t = (o[1] - o[0]) / (e[1] - e[0]);
    return o[0] + t * (r - e[0]);
  };
}
function Ie(e, [o, r]) {
  return Math.min(r, Math.max(o, e));
}
function de(e, o, r = "ltr") {
  const t = J(o), s = o.scrollbar.paddingStart + o.scrollbar.paddingEnd, l = o.scrollbar.size - s, n = o.content - o.viewport, c = l - t, i = r === "ltr" ? [0, n] : [n * -1, 0], d = Ie(e, i);
  return pe([0, n], [0, c])(d);
}
function $e(e, o, r, t = "ltr") {
  const s = J(r), l = s / 2, n = o || l, c = s - n, i = r.scrollbar.paddingStart + n, d = r.scrollbar.size - r.scrollbar.paddingEnd - c, h = r.content - r.viewport, u = t === "ltr" ? [0, h] : [h * -1, 0];
  return pe([i, d], u)(e);
}
function Se(e, o) {
  return e > 0 && e < o;
}
function U(e, o, { checkForDefaultPrevented: r = !0 } = {}) {
  return (t) => {
    e == null || e(t), (r === !1 || !t.defaultPrevented) && (o == null || o(t));
  };
}
const [je, ve] = be(
  "ScrollAreaScrollbar was not found in tree"
), we = T((e, o) => {
  const X = e, {
    sizes: r,
    hasThumb: t,
    onThumbChange: s,
    onThumbPointerUp: l,
    onThumbPointerDown: n,
    onThumbPositionChange: c,
    onDragScroll: i,
    onWheelScroll: d,
    onResize: h
  } = X, u = P(X, [
    "sizes",
    "hasThumb",
    "onThumbChange",
    "onThumbPointerUp",
    "onThumbPointerDown",
    "onThumbPositionChange",
    "onDragScroll",
    "onWheelScroll",
    "onResize"
  ]), a = D(), [p, b] = w(null), g = F(o, (v) => b(v)), y = E(null), x = E(""), { viewport: W } = a, R = r.content - r.viewport, V = N(d), z = N(c), O = G(h, 10), L = (v) => {
    if (y.current) {
      const C = v.clientX - y.current.left, H = v.clientY - y.current.top;
      i({ x: C, y: H });
    }
  };
  return A(() => {
    const v = (C) => {
      const H = C.target;
      (p == null ? void 0 : p.contains(H)) && V(C, R);
    };
    return document.addEventListener("wheel", v, { passive: !1 }), () => document.removeEventListener("wheel", v, { passive: !1 });
  }, [W, p, R, V]), A(z, [r, z]), B(p, O), B(a.content, O), /* @__PURE__ */ m(
    je,
    {
      value: {
        scrollbar: p,
        hasThumb: t,
        onThumbChange: N(s),
        onThumbPointerUp: N(l),
        onThumbPositionChange: z,
        onThumbPointerDown: N(n)
      },
      children: /* @__PURE__ */ m(
        "div",
        S(f({}, u), {
          ref: g,
          "data-mantine-scrollbar": !0,
          style: f({ position: "absolute" }, u.style),
          onPointerDown: U(e.onPointerDown, (v) => {
            v.preventDefault(), v.button === 0 && (v.target.setPointerCapture(v.pointerId), y.current = p.getBoundingClientRect(), x.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", L(v));
          }),
          onPointerMove: U(e.onPointerMove, L),
          onPointerUp: U(e.onPointerUp, (v) => {
            const C = v.target;
            C.hasPointerCapture(v.pointerId) && (v.preventDefault(), C.releasePointerCapture(v.pointerId));
          }),
          onLostPointerCapture: () => {
            document.body.style.webkitUserSelect = x.current, y.current = null;
          }
        })
      )
    }
  );
}), ge = T(
  (e, o) => {
    const u = e, { sizes: r, onSizesChange: t, style: s } = u, l = P(u, ["sizes", "onSizesChange", "style"]), n = D(), [c, i] = w(), d = E(null), h = F(o, d, n.onScrollbarXChange);
    return A(() => {
      d.current && i(getComputedStyle(d.current));
    }, [d]), /* @__PURE__ */ m(
      we,
      S(f({
        "data-orientation": "horizontal"
      }, l), {
        ref: h,
        sizes: r,
        style: S(f({}, s), {
          "--sa-thumb-width": `${J(r)}px`
        }),
        onThumbPointerDown: (a) => e.onThumbPointerDown(a.x),
        onDragScroll: (a) => e.onDragScroll(a.x),
        onWheelScroll: (a, p) => {
          if (n.viewport) {
            const b = n.viewport.scrollLeft + a.deltaX;
            e.onWheelScroll(b), Se(b, p) && a.preventDefault();
          }
        },
        onResize: () => {
          d.current && n.viewport && c && t({
            content: n.viewport.scrollWidth,
            viewport: n.viewport.offsetWidth,
            scrollbar: {
              size: d.current.clientWidth,
              paddingStart: q(c.paddingLeft),
              paddingEnd: q(c.paddingRight)
            }
          });
        }
      })
    );
  }
);
ge.displayName = "@mantine/core/ScrollAreaScrollbarX";
const ye = T(
  (e, o) => {
    const u = e, { sizes: r, onSizesChange: t, style: s } = u, l = P(u, ["sizes", "onSizesChange", "style"]), n = D(), [c, i] = w(), d = E(null), h = F(o, d, n.onScrollbarYChange);
    return A(() => {
      d.current && i(window.getComputedStyle(d.current));
    }, []), /* @__PURE__ */ m(
      we,
      S(f({}, l), {
        "data-orientation": "vertical",
        ref: h,
        sizes: r,
        style: f({
          "--sa-thumb-height": `${J(r)}px`
        }, s),
        onThumbPointerDown: (a) => e.onThumbPointerDown(a.y),
        onDragScroll: (a) => e.onDragScroll(a.y),
        onWheelScroll: (a, p) => {
          if (n.viewport) {
            const b = n.viewport.scrollTop + a.deltaY;
            e.onWheelScroll(b), Se(b, p) && a.preventDefault();
          }
        },
        onResize: () => {
          d.current && n.viewport && c && t({
            content: n.viewport.scrollHeight,
            viewport: n.viewport.offsetHeight,
            scrollbar: {
              size: d.current.clientHeight,
              paddingStart: q(c.paddingTop),
              paddingEnd: q(c.paddingBottom)
            }
          });
        }
      })
    );
  }
);
ye.displayName = "@mantine/core/ScrollAreaScrollbarY";
const K = T((e, o) => {
  const p = e, { orientation: r = "vertical" } = p, t = P(p, ["orientation"]), { dir: s } = Ue(), l = D(), n = E(null), c = E(0), [i, d] = w({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), h = me(i.viewport, i.content), u = S(f({}, t), {
    sizes: i,
    onSizesChange: d,
    hasThumb: h > 0 && h < 1,
    onThumbChange: (b) => {
      n.current = b;
    },
    onThumbPointerUp: () => {
      c.current = 0;
    },
    onThumbPointerDown: (b) => {
      c.current = b;
    }
  }), a = (b, g) => $e(b, c.current, i, g);
  return r === "horizontal" ? /* @__PURE__ */ m(
    ge,
    S(f({}, u), {
      ref: o,
      onThumbPositionChange: () => {
        if (l.viewport && n.current) {
          const b = l.viewport.scrollLeft, g = de(b, i, s);
          n.current.style.transform = `translate3d(${g}px, 0, 0)`;
        }
      },
      onWheelScroll: (b) => {
        l.viewport && (l.viewport.scrollLeft = b);
      },
      onDragScroll: (b) => {
        l.viewport && (l.viewport.scrollLeft = a(b, s));
      }
    })
  ) : r === "vertical" ? /* @__PURE__ */ m(
    ye,
    S(f({}, u), {
      ref: o,
      onThumbPositionChange: () => {
        if (l.viewport && n.current) {
          const b = l.viewport.scrollTop, g = de(b, i);
          i.scrollbar.size === 0 ? n.current.style.setProperty("--thumb-opacity", "0") : n.current.style.setProperty("--thumb-opacity", "1"), n.current.style.transform = `translate3d(0, ${g}px, 0)`;
        }
      },
      onWheelScroll: (b) => {
        l.viewport && (l.viewport.scrollTop = b);
      },
      onDragScroll: (b) => {
        l.viewport && (l.viewport.scrollTop = a(b));
      }
    })
  ) : null;
});
K.displayName = "@mantine/core/ScrollAreaScrollbarVisible";
const ne = T(
  (e, o) => {
    const r = D(), d = e, { forceMount: t } = d, s = P(d, ["forceMount"]), [l, n] = w(!1), c = e.orientation === "horizontal", i = G(() => {
      if (r.viewport) {
        const h = r.viewport.offsetWidth < r.viewport.scrollWidth, u = r.viewport.offsetHeight < r.viewport.scrollHeight;
        n(c ? h : u);
      }
    }, 10);
    return B(r.viewport, i), B(r.content, i), t || l ? /* @__PURE__ */ m(
      K,
      S(f({
        "data-state": l ? "visible" : "hidden"
      }, s), {
        ref: o
      })
    ) : null;
  }
);
ne.displayName = "@mantine/core/ScrollAreaScrollbarAuto";
const Pe = T(
  (e, o) => {
    const c = e, { forceMount: r } = c, t = P(c, ["forceMount"]), s = D(), [l, n] = w(!1);
    return A(() => {
      const { scrollArea: i } = s;
      let d = 0;
      if (i) {
        const h = () => {
          window.clearTimeout(d), n(!0);
        }, u = () => {
          d = window.setTimeout(() => n(!1), s.scrollHideDelay);
        };
        return i.addEventListener("pointerenter", h), i.addEventListener("pointerleave", u), () => {
          window.clearTimeout(d), i.removeEventListener("pointerenter", h), i.removeEventListener("pointerleave", u);
        };
      }
    }, [s.scrollArea, s.scrollHideDelay]), r || l ? /* @__PURE__ */ m(
      ne,
      S(f({
        "data-state": l ? "visible" : "hidden"
      }, t), {
        ref: o
      })
    ) : null;
  }
);
Pe.displayName = "@mantine/core/ScrollAreaScrollbarHover";
const qe = T(
  (e, o) => {
    const d = e, { forceMount: r } = d, t = P(d, ["forceMount"]), s = D(), l = e.orientation === "horizontal", [n, c] = w("hidden"), i = G(() => c("idle"), 100);
    return A(() => {
      if (n === "idle") {
        const h = window.setTimeout(() => c("hidden"), s.scrollHideDelay);
        return () => window.clearTimeout(h);
      }
    }, [n, s.scrollHideDelay]), A(() => {
      const { viewport: h } = s, u = l ? "scrollLeft" : "scrollTop";
      if (h) {
        let a = h[u];
        const p = () => {
          const b = h[u];
          a !== b && (c("scrolling"), i()), a = b;
        };
        return h.addEventListener("scroll", p), () => h.removeEventListener("scroll", p);
      }
    }, [s.viewport, l, i]), r || n !== "hidden" ? /* @__PURE__ */ m(
      K,
      S(f({
        "data-state": n === "hidden" ? "hidden" : "visible"
      }, t), {
        ref: o,
        onPointerEnter: U(e.onPointerEnter, () => c("interacting")),
        onPointerLeave: U(e.onPointerLeave, () => c("idle"))
      })
    ) : null;
  }
), oe = T(
  (e, o) => {
    const i = e, { forceMount: r } = i, t = P(i, ["forceMount"]), s = D(), { onScrollbarXEnabledChange: l, onScrollbarYEnabledChange: n } = s, c = e.orientation === "horizontal";
    return A(() => (c ? l(!0) : n(!0), () => {
      c ? l(!1) : n(!1);
    }), [c, l, n]), s.type === "hover" ? /* @__PURE__ */ m(Pe, S(f({}, t), { ref: o, forceMount: r })) : s.type === "scroll" ? /* @__PURE__ */ m(qe, S(f({}, t), { ref: o, forceMount: r })) : s.type === "auto" ? /* @__PURE__ */ m(ne, S(f({}, t), { ref: o, forceMount: r })) : s.type === "always" ? /* @__PURE__ */ m(K, S(f({}, t), { ref: o })) : null;
  }
);
oe.displayName = "@mantine/core/ScrollAreaScrollbar";
function Ge(e, o = () => {
}) {
  let r = { left: e.scrollLeft, top: e.scrollTop }, t = 0;
  return function s() {
    const l = { left: e.scrollLeft, top: e.scrollTop }, n = r.left !== l.left, c = r.top !== l.top;
    (n || c) && o(), r = l, t = window.requestAnimationFrame(s);
  }(), () => window.cancelAnimationFrame(t);
}
const Ce = T((e, o) => {
  const h = e, { style: r } = h, t = P(h, ["style"]), s = D(), l = ve(), { onThumbPositionChange: n } = l, c = F(o, (u) => l.onThumbChange(u)), i = E(void 0), d = G(() => {
    i.current && (i.current(), i.current = void 0);
  }, 100);
  return A(() => {
    const { viewport: u } = s;
    if (u) {
      const a = () => {
        if (d(), !i.current) {
          const p = Ge(u, n);
          i.current = p, n();
        }
      };
      return n(), u.addEventListener("scroll", a), () => u.removeEventListener("scroll", a);
    }
  }, [s.viewport, d, n]), /* @__PURE__ */ m(
    "div",
    S(f({
      "data-state": l.hasThumb ? "visible" : "hidden"
    }, t), {
      ref: c,
      style: f({
        width: "var(--sa-thumb-width)",
        height: "var(--sa-thumb-height)"
      }, r),
      onPointerDownCapture: U(e.onPointerDownCapture, (u) => {
        const p = u.target.getBoundingClientRect(), b = u.clientX - p.left, g = u.clientY - p.top;
        l.onThumbPointerDown({ x: b, y: g });
      }),
      onPointerUp: U(e.onPointerUp, l.onThumbPointerUp)
    })
  );
});
Ce.displayName = "@mantine/core/ScrollAreaThumb";
const re = T(
  (e, o) => {
    const l = e, { forceMount: r } = l, t = P(l, ["forceMount"]), s = ve();
    return r || s.hasThumb ? /* @__PURE__ */ m(Ce, f({ ref: o }, t)) : null;
  }
);
re.displayName = "@mantine/core/ScrollAreaThumb";
const Te = T(
  (s, t) => {
    var l = s, { children: e, style: o } = l, r = P(l, ["children", "style"]);
    const n = D(), c = F(t, n.onViewportChange);
    return /* @__PURE__ */ m(
      j,
      S(f({}, r), {
        ref: c,
        style: f({
          overflowX: n.scrollbarXEnabled ? "scroll" : "hidden",
          overflowY: n.scrollbarYEnabled ? "scroll" : "hidden"
        }, o),
        children: /* @__PURE__ */ m("div", { style: { minWidth: "100%", display: "table" }, ref: n.onContentChange, children: e })
      })
    );
  }
);
Te.displayName = "@mantine/core/ScrollAreaViewport";
var le = { root: "m_d57069b5", viewport: "m_c0783ff9", viewportInner: "m_f8f631dd", scrollbar: "m_c44ba933", thumb: "m_d8b5e363", corner: "m_21657268" };
const xe = {
  scrollHideDelay: 1e3,
  type: "hover",
  scrollbars: "xy"
}, Je = Ye(
  (e, { scrollbarSize: o, overscrollBehavior: r }) => ({
    root: {
      "--scrollarea-scrollbar-size": Ve(o),
      "--scrollarea-over-scroll-behavior": r
    }
  })
), Q = he((e, o) => {
  const r = te("ScrollArea", xe, e), ce = r, {
    classNames: t,
    className: s,
    style: l,
    styles: n,
    unstyled: c,
    scrollbarSize: i,
    vars: d,
    type: h,
    scrollHideDelay: u,
    viewportProps: a,
    viewportRef: p,
    onScrollPositionChange: b,
    children: g,
    offsetScrollbars: y,
    scrollbars: x,
    onBottomReached: W,
    onTopReached: R,
    overscrollBehavior: V
  } = ce, z = P(ce, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "scrollbarSize",
    "vars",
    "type",
    "scrollHideDelay",
    "viewportProps",
    "viewportRef",
    "onScrollPositionChange",
    "children",
    "offsetScrollbars",
    "scrollbars",
    "onBottomReached",
    "onTopReached",
    "overscrollBehavior"
  ]), [O, L] = w(!1), [X, v] = w(!1), [C, H] = w(!1), M = Xe({
    name: "ScrollArea",
    props: r,
    classes: le,
    className: s,
    style: l,
    classNames: t,
    styles: n,
    unstyled: c,
    vars: d,
    varsResolver: Je
  }), _ = E(null), Ae = Me([p, _]);
  return A(() => {
    if (!_.current || y !== "present")
      return;
    const Y = _.current, k = new ResizeObserver(() => {
      const { scrollHeight: Z, clientHeight: ee, scrollWidth: I, clientWidth: De } = Y;
      v(Z > ee), H(I > De);
    });
    return k.observe(Y), () => k.disconnect();
  }, [_, y]), /* @__PURE__ */ We(
    fe,
    S(f(f({
      type: h === "never" ? "always" : h,
      scrollHideDelay: u,
      ref: o,
      scrollbars: x
    }, M("root")), z), {
      children: [
        /* @__PURE__ */ m(
          Te,
          S(f(f({}, a), M("viewport", { style: a == null ? void 0 : a.style })), {
            ref: Ae,
            "data-offset-scrollbars": y === !0 ? "xy" : y || void 0,
            "data-scrollbars": x || void 0,
            "data-horizontal-hidden": y === "present" && !C ? "true" : void 0,
            "data-vertical-hidden": y === "present" && !X ? "true" : void 0,
            onScroll: (Y) => {
              var I;
              (I = a == null ? void 0 : a.onScroll) == null || I.call(a, Y), b == null || b({ x: Y.currentTarget.scrollLeft, y: Y.currentTarget.scrollTop });
              const { scrollTop: k, scrollHeight: Z, clientHeight: ee } = Y.currentTarget;
              k - (Z - ee) >= 0 && (W == null || W()), k === 0 && (R == null || R());
            },
            children: g
          })
        ),
        (x === "xy" || x === "x") && /* @__PURE__ */ m(
          oe,
          S(f({}, M("scrollbar")), {
            orientation: "horizontal",
            "data-hidden": h === "never" || !C || void 0,
            forceMount: !0,
            onMouseEnter: () => L(!0),
            onMouseLeave: () => L(!1),
            children: /* @__PURE__ */ m(re, f({}, M("thumb")))
          })
        ),
        (x === "xy" || x === "y") && /* @__PURE__ */ m(
          oe,
          S(f({}, M("scrollbar")), {
            orientation: "vertical",
            "data-hidden": h === "never" || !X || void 0,
            forceMount: !0,
            onMouseEnter: () => L(!0),
            onMouseLeave: () => L(!1),
            children: /* @__PURE__ */ m(re, f({}, M("thumb")))
          })
        ),
        /* @__PURE__ */ m(
          ke,
          S(f({}, M("corner")), {
            "data-hovered": O || void 0,
            "data-hidden": h === "never" || void 0
          })
        )
      ]
    })
  );
});
Q.displayName = "@mantine/core/ScrollArea";
const se = he((e, o) => {
  const z = te("ScrollAreaAutosize", xe, e), {
    children: r,
    classNames: t,
    styles: s,
    scrollbarSize: l,
    scrollHideDelay: n,
    type: c,
    dir: i,
    offsetScrollbars: d,
    viewportRef: h,
    onScrollPositionChange: u,
    unstyled: a,
    variant: p,
    viewportProps: b,
    scrollbars: g,
    style: y,
    vars: x,
    onBottomReached: W,
    onTopReached: R
  } = z, V = P(z, [
    "children",
    "classNames",
    "styles",
    "scrollbarSize",
    "scrollHideDelay",
    "type",
    "dir",
    "offsetScrollbars",
    "viewportRef",
    "onScrollPositionChange",
    "unstyled",
    "variant",
    "viewportProps",
    "scrollbars",
    "style",
    "vars",
    "onBottomReached",
    "onTopReached"
  ]);
  return /* @__PURE__ */ m(j, S(f({}, V), { ref: o, style: [{ display: "flex", overflow: "auto" }, y], children: /* @__PURE__ */ m(j, { style: { display: "flex", flexDirection: "column", flex: 1 }, children: /* @__PURE__ */ m(
    Q,
    {
      classNames: t,
      styles: s,
      scrollHideDelay: n,
      scrollbarSize: l,
      type: c,
      dir: i,
      offsetScrollbars: d,
      viewportRef: h,
      onScrollPositionChange: u,
      unstyled: a,
      variant: p,
      viewportProps: b,
      vars: x,
      scrollbars: g,
      onBottomReached: W,
      onTopReached: R,
      children: r
    }
  ) }) }));
});
Q.classes = le;
se.displayName = "@mantine/core/ScrollAreaAutosize";
se.classes = le;
Q.Autosize = se;
export {
  Q as S
};
